import { h } from 'preact';
import Store from 'store/store';
import * as categories from '../categories';
import * as oneTrustCategories from 'utils/gdpr/oneTrust/categories';
import * as queue from '../queue';
import passToIframe, { listenToIframe } from './iframe';
import { accessNested } from 'utils/utils';
import pendingPromise from 'utils/pendingPromise';
import { dispatchEvent } from '../dispatchEvent';

export { default as Pixel } from '../Pixel';
export { maybeHandle } from '../maybeHandle';
export { default as connectToOneTrust } from './connectToOneTrust';
export { default as createPixelComponent } from '../createPixelComponent';

export { STRICTLY_NECESSARY, FUNCTIONAL, TARGETING, ADVERTISING, PERFORMANCE } from '../constants';

export const displayModal = () => {
	if (typeof window === 'object') {
		const api = window.Optanon || window.OneTrust;
		if (api && typeof api === 'object' && typeof api.ToggleInfoDisplay === 'function') {
			api.ToggleInfoDisplay();
		}
	}
};

const loadPromise = pendingPromise();
export const waitForOneTrust = async () => loadPromise;

categories.addChangeListener((allowedCategories) => {
	dispatchEvent('categoriesUpdated', { categories: allowedCategories });
	queue.drain(allowedCategories);
});

function oneTrustFix() {
	if (!getCookie('OptanonAlertBoxClosed')) return;

	const oneTrust = Store.get().appData?.apis?.tracking?.oneTrust;
	const oneTrustFix = oneTrust?.oneTrustFix;
	const oneTrustOverlapFix = oneTrust?.oneTrustOverlapFix;
	if (oneTrustFix) {
		// ???
		const close = () => {
			let banner = document.getElementById('optanon');
			if (!banner) return;
			banner.style.opacity = '0';
			banner.style.transition = 'opacity .8s';
			setTimeout(() => {
				const bg = document.getElementById('optanon-popup-bg');
				if (bg) {
					bg.style.display = 'none';
					banner.style.opacity = '';
				}
			}, 800);
		};
		const buttons = document.querySelectorAll('.optanon-white-button-middle, .accept-cookies-button');
		[...buttons].forEach(button => button.addEventListener('click', close));
	}
	if (oneTrustOverlapFix) {
		setTimeout(() => {
			const pixelConsent = accessNested(Store.get(), 'client.pixelConsent');
			const bannerDisplay = document.querySelector('.optanon-alert-box-wrapper')?.style?.display;
			if (pixelConsent && bannerDisplay === 'none') {
				document.body.style.transform = '';
			}
		}, 800);
	}

}

function getCookie(name) {
	return `; ${document.cookie}`.split(`; ${name}=`)[1]?.split(';').shift();
}

if (typeof window !== 'undefined') {
	let isOptatonInitialised = false;
	const existingOptanonWrapper = window.OptanonWrapper;

	listenToIframe();

	// let justRejectedAll = false;
	window.OptanonWrapper = function() {
		if (typeof existingOptanonWrapper === 'function') {
			try {
				existingOptanonWrapper();
			} catch (e) {}
		}

		loadPromise.resolve();

		if (window.dataLayer) {
			window.dataLayer.push({ event: 'OneTrustGroupsUpdated' });
		}

		passToIframe();
		oneTrustFix();

		if (!isOptatonInitialised) {
			const activeGroups = window.OptanonActiveGroups;
			oneTrustCategories.set(activeGroups);
			isOptatonInitialised = true;
		}
	};

	window.addEventListener('consent.onetrust', ({ detail }) => oneTrustCategories.set(detail));
	window.addEventListener('OneTrustGroupsUpdated', ({ detail }) => oneTrustCategories.set(detail));
}
